import BuiltDifferentlyComparison from "@components/comparison-page-components/BuiltDifferentlyComparison";
import { ComparisonTableV2, ComparisonTableV2Header, ComparisonTableV2Data } from "@components/comparison-page-components/ComparisonTableV2";
import SecondaryCTASection from "@components/comparison-page-components/SecondaryCTASection";
import AwardsSection from "@components/new-ui/AwardsSection";
import ClientLogos from "@components/new-ui/ClientLogos";
import { container_classname } from "@components/new-ui/constants";
import CTACard from "@components/new-ui/CTACard";
import CTASection from "@components/new-ui/CTASection";
import Herosection from "@components/new-ui/IndustriesSection/Herosection";
import type { HerosectionProps } from "@components/new-ui/IndustriesSection/Herosection";
import IntegrationSection from "@components/new-ui/IntegrationSection";
import NewLayout from "@components/new-ui/Layout";
import type { BuiltDifferentlyData } from "types/compare";
import aisensyData from "@data/compare/aisensy.json";
import React from "react";

const { pageMetadata, heroSectionData, comparisonTableHeader, comparisonTableData, builtDifferentlyData, ctaData } = aisensyData as {
    pageMetadata: { title: string; description: string; canonical: string; ogImage: string };
    heroSectionData: HerosectionProps;
    comparisonTableHeader: ComparisonTableV2Header;
    comparisonTableData: ComparisonTableV2Data[];
    builtDifferentlyData: BuiltDifferentlyData;
    ctaData: { primary: { title: string; description: string; buttonText: string; buttonUrl: string }; secondary: { title: string; description: string } };
};

const AisensyComparison: React.FC = () => {
    return (
        <NewLayout description={pageMetadata.description} title={pageMetadata.title} canonical={pageMetadata.canonical} ogAttributes={{ image: pageMetadata.ogImage }}>
            <Herosection herosection={{ ...heroSectionData, showBookACall: true }} />

            <section className={`${container_classname} mt-10 mb-20`}>
                <h3 className="text-center text-lg font-normal py-5">TRUSTED BY 10,000+ BUSINESSES</h3>
                <ClientLogos />
            </section>

            <BuiltDifferentlyComparison builtDifferentlyData={builtDifferentlyData} />
            <CTACard
                title={ctaData.primary.title}
                description={ctaData.primary.description}
                primaryButtonText={ctaData.primary.buttonText}
                primaryButtonUrl={ctaData.primary.buttonUrl}
            />
            <ComparisonTableV2
                title="Why Gallabox is the smarter choice"
                description={
                    <>
                        Gallabox delivers far more than messaging—it&apos;s a <strong>business automation backbone</strong> for WhatsApp that streamlines customer journeys,
                        accelerates conversions, and powers high-velocity sales at scale.
                    </>
                }
                tableHeader={comparisonTableHeader}
                tableData={comparisonTableData}
            />
            <SecondaryCTASection title={ctaData.secondary.title} description={ctaData.secondary.description} primaryButtonText="Book a Demo" urlLink="/demo" />
            <IntegrationSection isLight />
            <AwardsSection />
            <CTASection title="Turn connections into conversions" primaryButtonText="Sign up for a free trial now" />
        </NewLayout>
    );
};

export default AisensyComparison;
